import React from 'react';
import Header from '../Integration/Header';
import FbDetailsGet from '../../Middleware/Firebase/FbDetailsGet';
import FooterMenu from '../Integration/FooterMenu'

function PageDetails() {
  return (
    <div>
      <Header />
      <FbDetailsGet/>
      <FooterMenu />
    </div>
  );
}

export default PageDetails;
